module.exports = __webpack_public_path__ + "media/images/athletes/4349-b4ce41a3bbae7f66f1d90039174e113e.png";